import gsap from "gsap"
import { qs, qsa, bounds } from "../utils"

export default class Marquee {
  constructor(el) {
    this.el = el

    this.inner = qs(".inner", this.el)
    this.marqueeItems = qsa(".marquee-text", this.el)
    this.width = bounds(this.marqueeItems[0]).width

    if (this.width === 0) {
      //display none because of responsive
      return
    }

    this.progress = 0
    this.direction = "left"
    this.duration = parseInt(this.el.getAttribute("data-duration")) || 10

    setTimeout(() => {
      this.resize()
      // this helps to fix some layout shifting happening before the computation of bounds
      // behavior observed on samples section
    }, 100)

    gsap.ticker.add(this.animate)
  }

  resize() {
    gsap.ticker.remove(this.animate)
    this.width = bounds(this.marqueeItems[0]).width

    gsap.ticker.add(this.animate)
    this.progress = 0
  }

  animate = (time, deltaTime) => {
    this.progress += (deltaTime * 0.0008) / this.duration

    if (this.progress >= 1) {
      this.progress = 0
    }

    let x
    if (this.direction === "left") {
      x = this.progress * -this.width
    } else {
      x = -this.width + this.progress * this.width
    }

    this.inner.style.transform = `translateX(${x}px)`
  }
}
